// src/components/ProtectedAdminRoute.js

import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { checkAdminStatus } from '../services/api';
import toast from 'react-hot-toast';

// This component now accepts `userIdToken` and `children` from props.
const ProtectedAdminRoute = ({ children, userIdToken }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        const verifyAdmin = async () => {
            // No need to check localStorage, we rely on the prop.
            if (!userIdToken) {
                setIsLoading(false);
                return; // Not logged in, will be redirected
            }

            try {
                // Use the token from props for the API call.
                const response = await checkAdminStatus(userIdToken);
                if (response.is_admin) {
                    setIsAdmin(true);
                    setUserInfo(response.user_info || {})
                }
            } catch (error) {
                toast.error("You do not have permission to access this page.");
            } finally {
                setIsLoading(false);
            }
        };

        verifyAdmin();
    }, [userIdToken]); // Effect depends on the token

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen bg-body text-p-text">
                Verifying permissions...
            </div>
        );
    }

    if (isAdmin) {
        // If the user is an admin, we render the child component (`AdminPage`).
        // We use React.cloneElement to pass the userIdToken prop to it.
        return React.cloneElement(children, { userIdToken: userIdToken, userInfo: userInfo });
    }

    // If not loading and not an admin, redirect.
    return <Navigate to="/chat" />;
};

export default ProtectedAdminRoute;